import { IconComponentType } from '@creditflowresearch/uilib/Icon';
import { ITool, IToolTransformContext, IToolLinkOption, IToolCategory, TOOL_CATEGORIES } from '@/creditflowresearch/domain/vo/ITools';
import LinkBuilder from '@/creditflowresearch/domain/Header/Tool/builders/LinkBuilder';
import ToolIconResolver from '@/creditflowresearch/domain/Header/Tool/utils/ToolIconResolver';
import ToolNameResolver from '@/creditflowresearch/domain/Header/Tool/utils/ToolNameResolver';
import ToolBadgeResolver from '@/creditflowresearch/domain/Header/Tool/utils/ToolBadgeResolver';
import ToolClassifier from '@/creditflowresearch/domain/Header/Tool/utils/ToolClassifier';

class ToolTransformer {
  static transformToLinkOption(
    tool: ITool,
    context: IToolTransformContext,
  ): IToolLinkOption {
    const linkContext = {
      activeProductAbbreviation: context.activeProductAbbreviation,
      activeRegionAbbreviation: context.activeRegionAbbreviation,
    };

    const link = LinkBuilder.buildLink(tool, linkContext);
    const IconComponent = ToolIconResolver.resolve(tool.id) as IconComponentType;
    const toolName = ToolNameResolver.resolveDisplayName(tool, context.productAbbreviation);
    const badges = ToolBadgeResolver.resolve(tool, context.productId);

    return {
      link,
      text: toolName,
      IconComponent,
      badges: badges.length > 0 ? badges : undefined,
    };
  }

  static categorize(tools: ITool[]): IToolCategory {
    return tools.reduce(
      (acc, tool) => {
        const category = ToolClassifier.classify(tool);

        if (category === TOOL_CATEGORIES.MARKET_OVERVIEW) {
          acc.marketOverviewTools.push(tool);
        } else {
          acc.regularTools.push(tool);
        }

        return acc;
      },
      { marketOverviewTools: [], regularTools: [] } as IToolCategory,
    );
  }
}

export default ToolTransformer;
